import * as React from "react";
import { mergeClasses } from "@fluentui/react-components";

import Logo from "./Logo";
import Settings from "./Settings";

import { ThemeContext } from "../store/theme-context-api";
import { useBrandBarStyles } from "../styles/styles";

export default function Footer() {
  const { isDarkTheme } = React.useContext(ThemeContext);
  const brandBarStyles = useBrandBarStyles();

  return (
    <nav
      className={mergeClasses(brandBarStyles.container, isDarkTheme ? brandBarStyles.dark : brandBarStyles.light)}
      style={{ bottom: "0px" }}
    >
      <Logo />
      <Settings />
    </nav>
  );
}
